import React, { useEffect, useState } from 'react';

import ClientGroupNumberCategoryRow from './ClientGroupNumberCategoryRow';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';
import CirclePlusIcon from 'Assets/icons/circle-plus.svg';

export default function ClientGroupNumbersTable(props) {
    const [request, setRequest] = useState(false);
    const [categories, setCategories] = useState([]);
    const [staticData, setStaticData] = useState([]);
    const [overrides, setOverrides] = useState({});
    const [sourceTags, setSourceTags] = useState({});
    const [error, setError] = useState('');
    const [allExpanded, setAllExpanded] = useState(false);
    const [expandKey, setExpandKey] = useState(0);

    useEffect(() => {
        setRequest(true);
        axios
            .get(props.clientGroupCategoriesUrl)
            .then(({ data }) => {
                setStaticData(data.staticData);
                setOverrides(data.overrides || {});
                setSourceTags(data.sourceTags || {});

                let clientGroupCategories = data.clientGroupCategories;
                let filtered = clientGroupCategories.filter((item) => ['Spectators', 'Workforce'].includes(item.name));
                clientGroupCategories = clientGroupCategories.filter((item) => !['Spectators', 'Workforce'].includes(item.name));
                clientGroupCategories.unshift(...filtered);

                setCategories(clientGroupCategories);
            })
            .catch((e) => {
                setError('There was an error fetching the Categories');
            })
            .finally(() => {
                setRequest(false);
            });
    }, []);

    const storeNewCategory = () => {
        axios
            .post(props.storeClientGroupCategoryUrl, {
                name: 'New Category',
            })
            .then((res) => {
                setCategories([
                    ...categories,
                    {
                        id: res.data.clientGroupCategory.id,
                        name: res.data.clientGroupCategory.name,
                        value: res.data.clientGroupCategory.value,
                        event_id: res.data.clientGroupCategory.event_id,
                        client_group_subcategories: [],
                        isNew: true,
                    },
                ]);
            })
            .catch((error) => {
                setError('There was an error creating a New Category');
            });
    };

    const handleToggleAll = () => {
        const next = !allExpanded;
        setAllExpanded(next);
        setExpandKey((k) => k + 1);
    };

    const handleOverrideChange = (rowKey, overrideData) => {
        setOverrides((prev) => {
            if (overrideData === null) {
                const next = { ...prev };
                delete next[rowKey];
                return next;
            }
            return { ...prev, [rowKey]: overrideData };
        });
    };

    return (
        <div className="tw-flex tw-flex-col tw-max-h-full tw-min-h-0">
            {error != '' && (
                <div className="alert alert-danger tw-flex-none">
                    <ul>
                        <li>{error}</li>
                    </ul>
                </div>
            )}

            <div className="table__card tw-flex tw-flex-col tw-min-h-0 tw-flex-auto">
                <div className="inbud-table_wrapper tw-overflow-auto tw-min-h-0 tw-flex-auto">
                    <table className="inbud-table tw-table-auto">
                        <thead className="tw-sticky tw-top-0 tw-z-10 tw-bg-white">
                            <tr>
                                <th className="tw-w-5/12">
                                    <div className="tw-flex tw-items-center tw-gap-x-2">
                                        <button
                                            type="button"
                                            onClick={handleToggleAll}
                                            className="tw-flex tw-items-center tw-gap-x-1 tw-text-xs tw-font-medium tw-text-charcoal-50 hover:tw-text-charcoal-75 tw-transition-colors tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
                                        >
                                            {allExpanded ? <ChevronUpIcon className="tw-w-3 tw-h-3" /> : <ChevronDownIcon className="tw-w-3 tw-h-3" />}
                                            <span>{allExpanded ? $t('Collapse all') : $t('Expand all')}</span>
                                        </button>
                                        <span className="tw-text-charcoal-50 tw-select-none">|</span>
                                        <span>{$t('Client Groups')}</span>
                                    </div>
                                </th>
                                <th className="tw-w-2/12">{$t('Total')}</th>
                                <th className="tw-w-5/12">{$t('Actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((category) => {
                                return (
                                    !(category.slug === 'sport_federations' && !category.event_id) && (
                                        <ClientGroupNumberCategoryRow
                                            key={category.id}
                                            category={category}
                                            staticData={staticData}
                                            overrides={overrides}
                                            sourceTags={sourceTags}
                                            onOverrideChange={handleOverrideChange}
                                            setError={setError}
                                            canCreate={props.canCreate}
                                            canUpdate={props.canUpdate}
                                            canDelete={props.canDelete}
                                            forceExpanded={allExpanded}
                                            expandKey={expandKey}
                                        />
                                    )
                                );
                            })}
                        </tbody>
                        <tfoot>
                            {!!props.canCreate && (
                                <tr className="!tw-bg-[#f1f1f1]">
                                    <td colSpan={3} className="tw-py-2.5">
                                        <button
                                            type="button"
                                            className="tw-h-8 tw-flex tw-items-center tw-gap-x-1.5 tw-px-5 tw-py-3 tw-bg-blue tw-text-white tw-font-semibold tw-rounded-full"
                                            onClick={() => storeNewCategory()}
                                        >
                                            <CirclePlusIcon className="tw-w-3 tw-h-3" />
                                            <div>{$t('Add Category')}</div>
                                        </button>
                                    </td>
                                </tr>
                            )}
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
}
